<div class="container">

  <!-- section title -->
  <h2 class="section-title wow fadeInUp">About Me</h2>

  <div class="spacer-60"></div>

  <div class="row">

    <div class="col-md-3">
      <div class="text-center text-md-left">
        <!-- avatar image -->
        <img src="assets/images/about-avatar.png" width="150" height="150" alt="Bolby" />
      </div>
      <div class="spacer-30 d-md-none d-lg-none"></div>
    </div>

    <div class="col-md-9 triangle-left-md triangle-top-sm">
      <div class="rounded bg-white shadow-dark padding-30">
        <div class="row">
          
            <!-- about text -->
            <p>Passionate about computers since I was young, I love problem solving, scripting, and cybersecurity in general.</p>
            <p>This portfolio is my little creative <span class="word-glow">laboratory</span>, here you'll find both completed projects and more ambitious drafts of what I'd like to implement. Most of the projects here are open source, and the code is reviewable on GitHub.</p>
            <p><span class="word-glow">Enjoy!</span><i class="fas fa-heart about-heart word-glow"></i></p>
            <div class="mt-3 cv-switcher-wrap">
              <div class="cv-switcher">
                <a href="../../../../assets/docs/CurriculumVitae_DavideGena.pdf" class="cv-option" aria-label="Download Curriculum Vitae in English">
                  <span class="cv-option-content"><i class="fas fa-download"></i><span class="cv-text-full">Curriculum Vitae (EN)</span><span class="cv-text-short">CV (EN)</span></span>
                </a>
                <span class="cv-divider"></span>
                <a href="../../../../assets/docs/EuropassCurriculumVitae_DavideGena.pdf" class="cv-option" aria-label="Scarica il Curriculum Vitae Europass in italiano">
                  <span class="cv-option-content"><i class="fas fa-download"></i><span class="cv-text-full">Europass Curriculum Vitae (IT)</span><span class="cv-text-short">Europass CV (IT)</span></span>
                </a>
              </div>
            </div>
            <div class="spacer-30 d-md-none d-lg-none"></div>

        </div>
      </div>
    </div>

  </div>
  <!-- row end -->

</div>
